<template>
  <div class="box p-5">
    <div class="flex flex-col sm:flex-row sm:items-start">
      <div>
        <div class="sm:flex">
          <div class="sm:mr-2">
            <InputSelect
              :options="officerList"
              v-model="form.officerId"
              :firstItemLabel="$t('text.allOfficers')"
              valueKey="id"
              labelKey="firstName"
              class="sm:w-40"
              :disabled="officerLoading"
            />
          </div>
          <div class="sm:mr-2">
            <InputSelect
              :options="bankAccountList"
              v-model="form.bankAccount"
              :firstItemLabel="$t('text.allBankAccounts')"
              valueKey="number"
              labelKey="name"
              class="sm:w-40"
              :disabled="officerLoading"
            />
          </div>
          <div class="sm:mr-2 mt-2 sm:mt-0">
            <InputDate v-model="form.startDate" :placeholder="$t('text.startDate')" />
          </div>
          <div class="sm:mr-2 mt-2 sm:mt-0">
            <InputDate
              v-model="form.endDate"
              :placeholder="$t('text.endDate')"
              :disabled-dates="{ to: new Date(form.startDate) }"
            />
          </div>
          <div class="sm:mr-2 mt-2 sm:mt-0">
            <button
              type="button"
              @click="$emit('onFilter')"
              :disabled="loading"
              class="button w-full sm:w-20 bg-theme-1 text-white"
            >
              {{ $t('table.filterGo') }}
            </button>
          </div>
        </div>
      </div>

      <div class="flex mt-5 sm:mt-0 sm:ml-auto">
        <Button
          v-if="downloadable"
          @click="$emit('onDownload')"
          :loading="downloading"
          class="w-full sm:w-auto flex items-center border text-gray-700 dark:bg-dark-5 dark:text-gray-300"
        >
          <DownloadIcon class="w-4 h-4 mr-2" />
          {{ $t('table.downloadRows') }}
        </Button>
      </div>
    </div>

    <div class="table-regular table-report">
      <div class="table-regular-holder">
        <table class="table mt-5">
          <thead>
            <!-- <tr>
              <template v-for="(column, columnIndex) in columns">
                <th v-if="!column.disabled" :key="`column-${columnIndex}`">
                  <div class="table-regular-col-title">
                    {{ column.label }}
                  </div>
                </th>
              </template>
            </tr> -->
            <template v-if="type === 'loan'">
              <tr>
                <th rowspan="3">
                  {{ $t('table.number') }}
                </th>
                <th colspan="2">Зээлдэгч</th>
                <th rowspan="3">Валют</th>
                <th rowspan="3">Бүт/ нэр</th>
                <th rowspan="3">Зээл олгосон огноо</th>
                <th rowspan="3">Зээл төлөгдөх огноо</th>
                <th rowspan="3">Зориулалт</th>
                <th colspan="6">Зээл</th>
              </tr>
              <tr>
                <th rowspan="2">Нэр</th>
                <th rowspan="2">Регистр</th>
                <th rowspan="2">Данс</th>
                <th rowspan="2">Хүү %</th>
                <th colspan="2">Дүн</th>
                <th colspan="2">Ажилтан</th>
              </tr>
              <tr>
                <th>Дансны валютаар</th>
                <th>Төгрөг</th>
                <th>Анх олгосон</th>
                <th>Хариуцсан</th>
              </tr>
            </template>
            <template v-else-if="type === 'creditAccountBalance'">
              <tr>
                <th>
                  {{ $t('table.number') }}
                </th>
                <th>Данс</th>
                <th>Зээлдэгч</th>
                <th>Валют</th>
                <th>Эхлэх огноо</th>
                <th>Дуусах огноо</th>
                <th>Олгосон дүн</th>
                <th>Зээлийн үлдэгдэл</th>
                <th>Үндсэн хүүний өр</th>
                <th>Торгуулийн хүү</th>
                <th>Харьцсан данс</th>
                <th>Гарсан данс</th>
                <th>Ангилал</th>
                <th>Хариуцагч</th>
                <th>Регистрийн дугаар</th>
              </tr>
            </template>
            <template v-else-if="type === 'loanRepayment'">
              <tr>
                <th rowspan="2">
                  {{ $t('table.number') }}
                </th>
                <th rowspan="2">Данс</th>
                <th rowspan="2">Дансны нэр</th>
                <th rowspan="2">Регистрийн дугаар</th>
                <th rowspan="2">Зээлдэгч</th>
                <th colspan="5">Төлөгдсөн</th>
                <th rowspan="2">Валют</th>
                <th rowspan="2">Ангилал</th>
                <th rowspan="2">Сегмент</th>
                <th rowspan="2">Үйл.а.чиглэл</th>
              </tr>
              <tr>
                <th>Огноо</th>
                <th>Нэм.хүү</th>
                <th>Хүү</th>
                <th>Зээл</th>
                <th>Бүгд</th>
              </tr>
            </template>
            <template v-else-if="type === 'endOfDay'">
              <tr>
                <th rowspan="2">
                  {{ $t('table.number') }}
                </th>
                <th rowspan="2">Он/сар/өдөр</th>
                <th rowspan="2">Нийт идэвхитэй зээлийн тоо</th>
                <th rowspan="2">Нийт төлөгдсөн зээлийн дүн</th>
                <th colspan="2">Нийт олгосон</th>
                <th rowspan="5">Хүүний орлого</th>
                <th colspan="2">Шимтгэлийн орлого</th>
                <th rowspan="2">Нэмэгдүүлсэн хүүний орлого</th>
                <th rowspan="2">Илүү төлөлт</th>
                <th rowspan="2">Банкны шимтгэл</th>
              </tr>
              <tr>
                <th>Зээлийн дүн</th>
                <th>Зээлийн тоо</th>
                <th>Олгосон</th>
                <th>Сунгасан</th>
              </tr>
            </template>
            <template v-else-if="type === 'extended'">
              <tr>
                <th rowspan="2">
                  {{ $t('table.number') }}
                </th>
                <th rowspan="2">Данс</th>
                <th rowspan="2">Дансны нэр</th>
                <th rowspan="2">Регистрийн дугаар</th>
                <th rowspan="2">Зээлдэгч</th>
                <th colspan="6">Сунгасан дүн</th>
                <th rowspan="2">Валют</th>
                <th rowspan="2">Ангилал</th>
                <th rowspan="2">Сегмент</th>
                <th rowspan="2">Ү/А чиглэл</th>
              </tr>
              <tr>
                <th>Огноо</th>
                <th>Хүү</th>
                <th>Сун.шимтгэл</th>
                <th>Нэм.хүү</th>
                <th>Үндсэн зээл</th>
                <th>Бүгд</th>
              </tr>
            </template>
            <template v-else="">
              <tr>
                <th rowspan="2">
                  {{ $t('table.number') }}
                </th>
                <th rowspan="2">Данс</th>
                <th rowspan="2">Зээлдэгч</th>
                <th colspan="2">Хугацаа хэтэрсэн огноо</th>
                <th rowspan="2">Зээлийн хүү</th>
                <th colspan="6">Хугацаа хэтэрсэн дүн</th>
                <th rowspan="2">Хэтэрсэн хоног</th>
                <th rowspan="2">Ангилал</th>
                <th rowspan="2">Монголбанк</th>
                <th rowspan="2">Хариуцагч</th>
              </tr>
              <tr>
                <th>Авсан огноо</th>
                <th>Төлөх огноо</th>
                <th>Үндсэн зээл</th>
                <th>Үндсэн зээлийн өр</th>
                <th>Хүү өр</th>
                <th>Тор.Хүү</th>
                <th>Хур.Хүү</th>
                <th>Хүү үндсэн</th>
              </tr>
            </template>
          </thead>
          <tbody>
            <template v-if="loading">
              <tr>
                <td :colspan="columns.length">
                  <div class="flex items-center justify-center">
                    <LoadingIcon icon="oval" class="w-5 h-5" />
                    <p class="text-gray-500 ml-3">{{ $t('table.loading') }}</p>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else-if="rows.length < 1">
              <tr>
                <td :colspan="columns.length + 1">
                  <div class="flex items-center justify-center">
                    <InboxIcon class="w-5 h-5 text-gray-500" />
                    <p class="text-gray-500 ml-3">{{ $t('table.noItems') }}</p>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr class="font-bold bg-gray-300 dark:bg-dark-2">
                <template v-if="type === 'loan'">
                  <td colspan="10"></td>
                  <td>{{ totalValues.totalAmount | currency }}</td>
                  <td>{{ totalValues.totalAmount | currency }}</td>
                  <td colspan="2"></td>
                </template>
                <template v-else-if="type === 'overdueLoan'">
                  <td colspan="6"></td>
                  <td>{{ totalValues.totalAmount | currency }}</td>
                  <td>
                    {{
                      (parseInt(totalValues.totalAmount) + parseInt(totalValues.totalDebt))
                        | currency
                    }}
                  </td>
                  <td>{{ totalValues.totalDebt | currency }}</td>
                  <td>{{ totalValues.totalIncreasedRate | currency }}</td>
                  <td>{{ totalValues.hurHuu | currency }}</td>
                  <td>{{ totalValues.undsenHuu | currency }}</td>
                  <td colspan="4"></td>
                </template>
                <template v-else-if="type === 'extended'">
                  <td colspan="6"></td>
                  <td>{{ totalValues.totalDebt | currency }}</td>
                  <td>{{ totalValues.extendedFee | currency }}</td>
                  <td>{{ totalValues.totalIncreasedRate | currency }}</td>
                  <td>{{ totalValues.totalAmount | currency }}</td>
                  <td>{{ totalValues.extendedAmount | currency }}</td>
                  <td colspan="4"></td>
                </template>
                <template v-else-if="type === 'loanRepayment'">
                  <td colspan="6"></td>
                  <td>{{ totalValues.totalIncreasedRate | currency }}</td>
                  <td>{{ totalValues.totalRate | currency }}</td>
                  <td>{{ totalValues.totalAmount | currency }}</td>
                  <td>{{ totalValues.totalPaidAmount | currency }}</td>
                  <td colspan="4"></td>
                </template>
                <template v-else-if="type === 'endOfDay'">
                  <td colspan="12"></td>
                </template>
                <template v-else>
                  <td colspan="7"></td>
                  <td>{{ totalValues.totalAmount | currency }}</td>
                  <td>{{ totalValues.totalRate | currency }}</td>
                  <td>{{ totalValues.totalIncreasedRate | currency }}</td>
                  <td></td>
                  <td></td>
                  <td colspan="6"></td>
                </template>
              </tr>
              <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
                <td>{{ (page - 1) * perPage + rowIndex + 1 }}</td>
                <template v-for="(column, columnIndex) in columns">
                  <td
                    v-if="!column.disabled"
                    :key="columnIndex"
                    :class="{ 'table-report__action w-56': column.field === 'action' }"
                  >
                    <slot name="table-row" :column="column" :row="row">
                      <template v-if="column.field === 'userName'">
                        {{ row.user | fullName }}
                      </template>
                      <template v-else-if="column.field === 'userRegister'">
                        {{ row.user ? row.user.registrationNumber : '' }}
                      </template>
                      <p v-else-if="column.field === 'productName'" class="whitespace-nowrap">
                        {{ row.product ? row.product.name : '' }}
                      </p>
                      <template v-else-if="column.field === 'amount'">
                        {{ row.amount ? $options.filters.currency(row.amount.amount) : '' }}
                      </template>
                      <template v-else-if="column.field === 'rateAmount'">
                        {{ row.rateAmount | currency }}
                      </template>
                      <template v-else-if="column.field === 'increaseRateAmount'">
                        {{ row.increaseRateAmount | currency }}
                      </template>
                      <template v-else-if="column.field === 'totalRateAmount'">
                        {{ row.totalRateAmount | currency }}
                      </template>
                      <template v-else-if="column.field === 'paidAmount'">
                        {{ row.paidAmount | currency }}
                      </template>
                      <template v-else-if="column.field === 'officerName'">
                        {{ row.officer ? row.officer.firstName : '' }}
                      </template>
                      <template v-else-if="column.field === 'firstOfficerName'">
                        {{ row.firstOfficer ? row.firstOfficer.firstName : '' }}
                      </template>
                      <template v-else-if="column.field === 'borrower'">
                        {{ row.user.id }} - {{ row.user.firstName }}
                      </template>
                      <template v-else-if="column.field === 'totalLoanPaidAmount'">
                        {{ row.totalLoanPaidAmount | currency }}
                      </template>
                      <template v-else-if="column.field === 'totalLoanIssuedAmount'">
                        {{ row.totalLoanIssuedAmount | currency }}
                      </template>
                      <template v-else-if="column.field === 'interestIncome'">
                        {{ row.interestIncome | currency }}
                      </template>
                      <template v-else-if="column.field === 'feeIncome'">
                        {{ row.feeIncome | currency }}
                      </template>
                      <template v-else-if="column.field === 'extendedRateAmount'">
                        {{ row.interestRate | currency }}
                      </template>
                      <template v-else-if="column.field === 'extendedFeeIncome'">
                        {{ row.extendedFeeIncome | currency }}
                      </template>
                      <template v-else-if="column.field === 'extendedIncreaseRateAmount'">
                        {{ row.increasedInterestRate | currency }}
                      </template>
                      <template v-else-if="column.field === 'extendedLoanAmount'">
                        {{ row.loan ? $options.filters.currency(row.loan.amount) : '' }}
                      </template>
                      <template v-else-if="column.field === 'increaseInterestIncome'">
                        {{ row.increaseInterestIncome | currency }}
                      </template>
                      <template v-else-if="column.field === 'overPayment'">
                        {{ row.overPayment | currency }}
                      </template>
                      <template v-else-if="column.field === 'bankFee'">
                        {{ row.bankFee | currency }}
                      </template>
                      <template v-else-if="column.field === 'payAmount'">
                        {{ row.payAmount | currency }}
                      </template>
                      <template v-else-if="column.field === 'hurRate'">
                        {{ row.hurRate | currency }}
                      </template>
                      <template v-else-if="column.field === 'undsenRate'">
                        {{ row.undsenRate | currency }}
                      </template>
                      <template v-else-if="column.field === 'loan.account'">
                        {{ row.loan.account | fullName }}
                      </template>
                      <template v-else-if="column.field === 'loan.userName'">
                        {{ row.loan.user | fullName }}
                      </template>
                      <template v-else-if="column.field === 'loan.userRegister'">
                        {{ row.loan.user ? row.loan.user.registrationNumber : '' }}
                      </template>
                      <template v-else-if="column.field === 'loan.productName'">
                        {{ row.loan.product ? row.loan.product.name : '' }}
                      </template>
                      <template v-else-if="column.field === 'loan.borrower'">
                        {{ row.loan.user.id }} - {{ row.loan.user.firstName }}
                      </template>
                      <p class="whitespace-nowrap" v-else-if="column.field === 'extendedDate'">
                        {{
                          row.createdAt
                            ? $options.filters.momentDate(row.createdAt, 'YYYY-MM-DD HH:mm')
                            : ''
                        }}
                      </p>
                      <template v-else-if="column.field === 'extendedExtensionFee'">
                        {{ 200000 | currency }}
                      </template>
                      <template v-else-if="column.field === 'extendedTotalAmount'">
                        {{ row.paidAmount | currency }}
                      </template>
                      <p class="whitespace-nowrap" v-else-if="column.field === 'createdAt'">
                        {{ row.createdAt }}
                      </p>
                      <p class="whitespace-nowrap" v-else-if="column.field === 'endDate'">
                        {{ row.endDate }}
                      </p>
                      <p class="whitespace-nowrap" v-else-if="column.field === 'paidDate'">
                        {{ row.paidDate }}
                      </p>
                      <p class="whitespace-nowrap" v-else-if="column.field === 'startDate'">
                        {{ row.startDate }}
                      </p>
                      <p class="whitespace-nowrap" v-else-if="column.field === 'userBank'">
                        {{ row.user.banks[0].accountNumber }}
                      </p>
                      <p class="whitespace-nowrap" v-else-if="column.field === 'bankAccount'">
                        {{ row.bankAccount }}
                      </p>
                      <div v-else-if="column.field === 'loanStatus'" class="whitespace-nowrap">
                        <div :class="['status', `is-loan-status-${getStatus(row.overdueDay)}`]">
                          {{ $t(`loanStatus.${getStatus(row.overdueDay)}`) }}
                        </div>
                      </div>
                      <div
                        v-else-if="column.field === 'loanStatusOfCentralBank'"
                        class="whitespace-nowrap"
                      >
                        <div
                          :class="[
                            'status',
                            `is-loan-status-${getStatusOfCentralBank(row.overdueDay)}`,
                          ]"
                        >
                          {{ $t(`loanStatus.${getStatusOfCentralBank(row.overdueDay)}`) }}
                        </div>
                      </div>
                      <template v-else="">
                        {{ row[column.field] }}
                      </template>
                    </slot>
                  </td>
                </template>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <TablePagination
        @onPerPageChange="onPerPageChange($event)"
        @onPageChange="onPageChange"
        :page="page"
        :per-page="perPage"
        :page-size="pageSize"
        :total-page="totalPage"
        :total-records="totalRecords"
      />
    </div>
  </div>
</template>

<script>
import TablePagination from '@/components/ui/table/TablePagination';
import Button from '@/components/ui/button/Button';
import InputDate from '@/components/ui/input/InputDate';
import InputSelect from '@/components/ui/input/InputSelect';

export default {
  components: { TablePagination, Button, InputDate, InputSelect },

  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
    downloading: Boolean,
    page: Number,
    perPage: Number,
    pageSize: Array,
    totalPage: Number,
    totalRecords: Number,
    type: String,
    downloadable: {
      type: Boolean,
      default: false,
    },
    form: Object,
    officerList: Array,
    officerLoading: Boolean,
    bankAccountList: Array,
    meta: [String, Object],
  },

  computed: {
    totalValues() {
      const {
        totalAmount,
        totalPaidAmount,
        totalRate,
        totalDebt,
        totalIncreasedRate,
        extendedFee,
        extendedAmount,
        hurHuu,
        undsenHuu,
      } = this.meta;
      return {
        totalAmount: totalAmount || 0,
        totalPaidAmount: totalPaidAmount || 0,
        totalRate: totalRate || 0,
        totalIncreasedRate: totalIncreasedRate || 0,
        totalDebt: totalDebt || 0,
        extendedFee: extendedFee || 0,
        extendedAmount: extendedAmount || 0,
        hurHuu: hurHuu || 0,
        undsenHuu: undsenHuu || 0,
      };
    },
  },

  methods: {
    onPageChange(page) {
      this.$emit('onPageChange', page);
    },
    onPerPageChange($event) {
      this.$emit('onPerPageChange', parseInt($event.target.value, 10));
    },
    getStatus(value) {
      let status = 'normal';
      const day = parseInt(value, 10);

      if (day > 30) {
        status = 'overdue';
      }
      if (day > 59) {
        status = 'notnormal';
      }
      if (day > 89) {
        status = 'doubtful';
      }
      if (day > 120) {
        status = 'unreliable';
      }

      return status;
    },
    getStatusOfCentralBank(value) {
      let status = 'normal';
      const day = parseInt(value, 10);

      if (day > 90) {
        status = 'attention';
      }
      if (day > 120) {
        status = 'notnormal';
      }
      if (day > 180) {
        status = 'doubtful';
      }
      if (day > 360) {
        status = 'bad';
      }

      return status;
    },
  },
};
</script>
